import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import toast from 'react-hot-toast';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Modal,
  Card,
} from 'react-bootstrap';

const DeleteDialog = ({
  path,
  buttonLabel = 'Delete',
  onSuccess,
  icon = '', // cross | button | ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const token = localStorage.getItem('token');

  const handleDelete = async () => {
    const deleting = toast.loading('Deleting...');
    try {
      const response = await fetch(`${path}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Deletion failed');
      }

      toast.success(data.message || 'Deleted successfully!', { id: deleting });
      setIsOpen(false);
      onSuccess?.();
    } catch (error) {
      toast.error(error.message || 'Something went wrong', { id: deleting });
    }
  };

  // 🔸 Render logic for trigger
  const renderTrigger = () => {
    if (icon === 'cross') {
      return (
        <span
          onClick={() => setIsOpen(true)}
          title="Remove"
          style={{
            cursor: 'pointer',
            fontSize: '14px', // 👈 Smaller size (you can try 12px too)
            color: '#ef4444',
            marginLeft: '8px',
            display: 'inline-block',
            verticalAlign: 'middle',
            lineHeight: 1,
          }}
        >
          ❌
        </span>
      );
    } else if (icon === 'button') {
      return (

        <Button
          variant="light"
          size="sm"
          onClick={() => setIsOpen(true)}
        >
          <span className="material-icons me-1 danger " style={{ fontSize: 16, color: "red" }}>
            delete
          </span>
        </Button>
      );
    } else {
      return (
        <button

          size="sm"
          className="border-0"
          onClick={() => setIsOpen(true)}
        >
          <span className="material-icons me-1 danger " style={{ fontSize: 16, color: "red" }}>
            delete
          </span>
        </button>
      );
    }
  };

  return (
    <>
      {renderTrigger()}

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="fixed inset-0 overflow-y-auto"
        style={{ zIndex: 9999 }}
      >
        <div
          className="flex items-center justify-center min-h-screen"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
        >
          <Dialog.Panel
            className="bg-white p-6 rounded shadow-lg"
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '300px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            }}
          >
            <Dialog.Title style={{ fontSize: '18px', fontWeight: 'bold' }}>
              Are you sure?
            </Dialog.Title>
            <Dialog.Description style={{ margin: '10px 0', fontSize: '14px' }}>
              This action is irreversible.
            </Dialog.Description>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                marginTop: '20px',
              }}
            >
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: '6px 14px',
                  backgroundColor: '#ddd',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                style={{
                  padding: '6px 14px',
                  backgroundColor: '#ef4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Delete
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default DeleteDialog;
